import { render, staticRenderFns } from "./AddTasks.vue?vue&type=template&id=2c3c6298&scoped=true"
import script from "./AddTasks.vue?vue&type=script&lang=js"
export * from "./AddTasks.vue?vue&type=script&lang=js"
import style0 from "./AddTasks.vue?vue&type=style&index=0&id=2c3c6298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c6298",
  null
  
)

export default component.exports